export default "__VITE_ASSET__y2IAOGC6__"